import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { COLORS } from '../../constants'
import { Container } from './Section'

type PageHeroProps = {
    eyebrow: string
    title: string
    intro?: ReactNode
    actions?: ReactNode
}

/** Dark intro band used at the top of every interior page. */
function PageHero({ eyebrow, title, intro, actions }: PageHeroProps) {
    return (
        <Box component="header" sx={{ backgroundColor: COLORS.black, color: COLORS.white, pt: { xs: 6, md: 10 }, pb: { xs: 7, md: 10 }, borderBottom: `1px solid ${COLORS.blackBorder}` }}>
            <Container>
                <Typography variant="overline" component="p" sx={{ color: COLORS.accent, mb: 1.5 }}>{eyebrow}</Typography>
                <Typography variant="h1" sx={{ maxWidth: 820 }}>{title}</Typography>
                {intro && (
                    <Typography sx={{ mt: 2.5, maxWidth: 680, color: COLORS.mutedOnDark, fontSize: { xs: '1.05rem', md: '1.2rem' } }}>
                        {intro}
                    </Typography>
                )}
                {actions && <Box sx={{ mt: 4, display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>{actions}</Box>}
            </Container>
        </Box>
    )
}

export default PageHero
